import { useState } from 'react';
import CommonTabContent from '../../../components/common-tab-content';

const options = ['Classify text', 'Detect primary and secondary intent', 'Analyze sentiment'];
interface PromptText {
	[key: number]: string;
}
const promptText: PromptText = {
	0: 'Classify the given text into one of these categories: {}. Output only the selected category, with no accompanying message.',
	1: `Analyze the given text and identify the intent behind it. Output in the format:
	"PRIMARY INTENT: {Main goal of the text}
	SECONDARY INTENT: {Secondary goal of the text}"
	There should only ever be one primary intent and one secondary intent. Provide output in markdown format.`,
	2: 'Analyze the given text and identify the overall sentiment behind it. Use a scale from -1 to +1, where -1 is a strong negative sentiment, and +1 is a strong positive sentiment. Output only this sentiment value, and a label of {Positive, Negative, Neutral}, with no accompanying message.',
};

const ClassifyTabContent: React.FC = () => {
	const [promptValue, setPromptValue] = useState<string>(promptText[0]);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOptionIndex = parseInt(e.target.value);
		setPromptValue(promptText[selectedOptionIndex]);
	};
	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select
					className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
					onChange={handleSelectChange}
				>
					{options.map((item, index) => (
						<option key={index} value={index}>
							{item}
						</option>
					))}
				</select>
			</div>
			<CommonTabContent defaultPrompt={promptValue} />
		</div>
	);
};

export default ClassifyTabContent;
